import { Controller } from '@hotwired/stimulus';

/* This Stimulus controller manages the visibility and state of subpermission blocks
based on the selected value of an apps policy dropdown. When the controller connects
or the dropdown value changes, it updates the UI by showing the relevant block
(read-write, read-only, or no-access) and hiding the others. It also enables or
disables the select inputs by setting their 'name' attribute, ensuring only the
active block's inputs are submitted with the form. */

export default class extends Controller {
  static targets = ['appsPolicySelect', 'assetsPolicySelect', 'appsReadWriteBlock', 'appsReadOnlyBlock', 'appsNoAccessBlock', 'assetsReadWriteBlock'];

  connect() {
    this.updateAppsSubpermissions();
    this.updateAssetsSubpermissions();
  }

  updateSubpermissions(type) {
    const policySelectTarget = this[`${type}PolicySelectTarget`];
    const policy = policySelectTarget.value;
    const config = this.getBlockConfigs(type, policy);

    this.toggleBlocks(config.show, true, type);
    config.hide.forEach(blocks => this.toggleBlocks(blocks, false, type));
  }

  getBlockConfigs(type, policy) {
    const configs = {
      apps: {
        read_write: { show: this.appsReadWriteBlockTargets, hide: [this.appsReadOnlyBlockTargets, this.appsNoAccessBlockTargets] },
        read_only: { show: this.appsReadOnlyBlockTargets, hide: [this.appsReadWriteBlockTargets, this.appsNoAccessBlockTargets] },
        default: { show: this.appsNoAccessBlockTargets, hide: [this.appsReadWriteBlockTargets, this.appsReadOnlyBlockTargets] }
      },
      assets: {
        read_write: { show: this.assetsReadWriteBlockTargets, hide: [] },
        read_only: { show: [], hide: [this.assetsReadWriteBlockTargets] },
        default: { show: [], hide: [this.assetsReadWriteBlockTargets] }
      }
    };
    return configs[type][policy] || configs[type].default;
  }

  toggleBlocks(blocks, isVisible, type) {
    blocks.forEach(block => {
      if (type == 'apps') {
        const input = block.querySelector('select');
        input.name = isVisible ? input.dataset.name : '';
      }
      block.classList.toggle('hidden', !isVisible);
    });
  }

  updateAssetsSubpermissions() {
    this.updateSubpermissions('assets');
  }

  updateAppsSubpermissions() { 
    this.updateSubpermissions('apps');
  }
}
